import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-content',
  templateUrl: './skeleton-content.component.html',
  styleUrls: ['./skeleton-content.component.scss'],
})
export class SkeletonContentComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
